// extracted by mini-css-extract-plugin
export var BlogPostThumb = "BlogPostThumb-module--BlogPostThumb--Om9r+";
export var aniSpin = "BlogPostThumb-module--ani-spin--q2Isu";
export var image = "BlogPostThumb-module--image--KdWc8";
export var image__filter = "BlogPostThumb-module--image__filter--c92vz";
export var image__hover = "BlogPostThumb-module--image__hover--tMGNA";
export var image__inner = "BlogPostThumb-module--image__inner--v-pYi";
export var image__overlay = "BlogPostThumb-module--image__overlay--xRrsy";
export var image__sizer = "BlogPostThumb-module--image__sizer--uZs0I";
export var text = "BlogPostThumb-module--text--8veZp";